<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-yellow" sprite="devices" />
          Devices
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-yellow" sprite="devices" />
            Devices
          </h1>
        </el-col>
        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total | number }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable> </el-input>
        </div>
        <div class="box right">
          <el-pagination
            small
            background
            layout="prev, pager, next"
            @current-change="pageSet"
            @next-click="pageNext"
            @prev-click="pagePrevious"
            :current-page="page"
            :page-size="limit"
            :pager-count="5"
            :total="total"
          />
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions } from "vuex";
import feathersClient from "@/feathers/feathers-client";

export default {
  name: "GlobalDevicesTable",
  data() {
    return {
      search: "",
      limit: 150,
      page: 1,
      pages: 1,
      total: 0,
      tableData: [],
      visibleActionsId: "",
      clearFormFields: false,
      editVisible: false,
      editProcessing: false,
      createVisible: false,
      createProcessing: false,
      mac: null,
      macInUse: false,
      deviceModelOptions: [],
      phonebooksOptions: [],
      selectedDevice: null,
      tableLoading: false,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-yellow" sprite="devices" />
                </div>
              ];
            }
          }
        },
        {
          field: 'name',
          title: 'Name',
          sortable: true,
          minWidth: 150,
          showOverflow: true
        },
        {
          field: 'tenantName',
          title: 'Account',
          sortable: true,
          minWidth: 150,
          showOverflow: true
        },
        {
          field: 'deviceModel',
          title: 'Model',
          sortable: true,
          minWidth: 100,
          showOverflow: false
        },
        {
          field: 'mac',
          title: 'MAC Address',
          sortable: true,
          minWidth: 150,
          showOverflow: false
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'delete-'+row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ]
            }
          }
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.populateTable();
    },

    user() {
      this.populateTable();
    },

    page: debounce(function() {
      this.populateTable();
    }, 500),

    search: debounce(function() {
      this.populateTable();
    }, 500)
  },

  methods: {
    ...mapActions("devices", {
      createDevice: "create",
      deleteDevice: "remove",
      editDevice: "patch"
    }),

    //General Form and Table Operations
    cellClicked(data) {
      if(data.column.property !== 'actions'){
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },

    populateTable() {
      let params = {
        query: {
          $limit: this.limit,
          $skip: this.page > 1 ? this.limit * (this.page - 1) : 0,
          $or: [
            { name: { $like: `%${this.search}%` } },
            { mac: { $like: `%${this.search}%` } }
          ]
        }
      };

      if(+this.user.userRole === 3 || +this.user.userRole === 12) {
        params.query.tenantId = {$in: this.user.tenantIds}
      }

      //if this is a platform admin let's just grab the first few tenants and let remote search from there.
      if(+this.user.userRole === 11 && !this.search.length){
        const partnerTenants = [...this.$store.state.authTenants];
        const partnerTenantsLength = partnerTenants.length;
        const queryTenantIds = [];
        if(partnerTenantsLength){
          for(let i = 0; i < 6; i++){
            if(i > partnerTenantsLength - 1){
              break;
            }
            queryTenantIds.push(partnerTenants[i].id);
          }
        }
        params.query.tenantId = {$in: queryTenantIds};
      }

      //if partner admin is searching, we will check tenant ids on the backend instead.
      if(+this.user.userRole === 11 && this.search.length){
        params.query.tenantId = 'partnerAdminGlobals';
      }

      this.tableLoading = true;
      feathersClient.service('devices').find(params).then(res => {
        this.limit = res.limit;
        this.pages = Math.ceil(res.total / res.limit);
        this.total = res.total;
        this.page = this.page > this.pages ? 1 : this.page;
        this.tableData = res.data;
        this.tableLoading = false;
      });
    },

    deleteOperation(id) {
      this.$confirm("Delete device?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteDevice(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
              this.populateTable();
              this.tableLoading = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    pageNext() {
      if (this.page < this.pages) {
        this.page += 1;
      }
    },
    pagePrevious() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    pageSet(page) {
      this.page = page;
    }
  },

  filters: {
    number(value) {
      return !isNaN(value)
        ? new Intl.NumberFormat("en-US").format(value)
        : value;
    }
  },

  mounted() {
    if (this.user) {
      this.populateTable();
    }
  }
};
</script>
